var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSubAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#005993"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.443 19.778a23.538 23.538 0 0 0-3.4-2.083.126.126 0 0 1-.072-.114v-1.379c.211-.36.347-.737.398-1.082.155-.012.354-.226.572-.994.296-1.049-.018-1.203-.284-1.179a2.53 2.53 0 0 0 .114-.432c.454-2.717-.885-2.81-.885-2.81s-.22-.427-.807-.75c-.39-.233-.937-.411-1.653-.35a2.45 2.45 0 0 0-.659.126c-.263.091-.505.221-.725.372-.27.17-.523.378-.747.617-.354.362-.67.83-.807 1.414-.115.435-.087.892.006 1.381.027.142.064.287.115.432-.266-.024-.583.13-.284 1.18.218.767.42.981.571.993.055.348.19.732.4 1.095v1.366a.126.126 0 0 1-.073.114c-.339.167-1.838.922-3.4 2.083a3.07 3.07 0 0 0-1.23 2.463v.372c0 .438.356.794.794.794h12.486a.796.796 0 0 0 .794-.794v-.372a3.027 3.027 0 0 0-1.224-2.463z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSubAvatar);
export default __webpack_public_path__ + "static/media/ic_subAvatar.cb3eb091b28b7f3cef4b4341862bfd8e.svg";
export { ForwardRef as ReactComponent };